const dimensionQueryKeys = {
  getDimensionsListQueryKeys: () => {
    return ['dimensions'];
  },
};

export default dimensionQueryKeys;
